import React, { type HTMLAttributes, type PropsWithChildren } from 'react';
import cx from 'classnames';
import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import stylesheet from './Modal.css';

const ModalContent: React.FC<
  PropsWithChildren & HTMLAttributes<HTMLElement>
> = ({ children, className, ...rest }) => {
  const isRedesigned = mcdsFlagCheck(
    'xp_mcds_redesign_components_organisms_part_2',
  );

  return (
    <div
      className={cx(stylesheet.content, className)}
      style={isRedesigned ? undefined : { flexGrow: 2 }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default ModalContent;
